<template>
    <div style="height: 100%;">
        <course-statistics :courseInfo="currentItem" ref="course_statistics" v-if="opt=='courseStatstics'"></course-statistics>
        <my-course-detail ref="my_course_detail" :courseId="currentItem.id" v-else-if="opt=='courseDetail'"></my-course-detail>
        <div class="course-box" v-else>
            <div class="create-course-box" v-if="['add','edit'].includes(opt)">
                <create-course :disabled="isDisabled"></create-course>
            </div>
            <div class="create-box" v-else>
            <div class="top-box">
                <div class="btn-box" @click="createCourse" v-if="!$permission('myselfCourse::createCourse')">
                    <i class="iconfont icon-jiahao"></i>
                    创建课程
                </div>
                <div class="input-box">
                    <div @click="search">搜索</div>
                    <el-input v-model="keywords" clearable @clear="search" style="width: 20rem;" @keydown.enter.native="search" placeholder="请输入关键字">
                        <template slot="prefix">
                            <div class="search-ipt-box">
                                <img style="cursor: pointer;width: 16px;height: auto;" src="../../assets/image/magSys/search.png" @click="search" alt="">
                            </div>
                        </template>
                    </el-input>
                    <div class="btn-box" style="margin-left: 3rem;" @click.stop="openFilter">
                        <img style="margin-right: 0.5rem;width: 16px;height: auto;" src="../../assets/image/magSys/filter.png" alt="">
                        课程筛选
                    </div>
                </div>
            </div>
            <div class="card-content" v-show="tableData.length>0">
                <course-card class="card-item" v-for="(item,index) in tableData" :publish="publishStatus(item.courseStatus)" :dropdown="filterBtn(item.courseStatus)" @edit="editCourse(item)" @to_detail="detail(item)" @del="deleteCourse(item)" @courseInfo="courseInfo(item)" @noPublish="noPublish(item)" @publish="publish(item)" @queryRecord="openRecord(item)" @endCourse="endCourse(item)" :key="index" :cardData="item"></course-card>
            </div>
            <no-data style="height: calc(100% - 7rem);" v-show="tableData.length==0"></no-data>
            <div  v-if="tableData.length>0" style="text-align: center;padding: 2rem 0;">
                <el-pagination
                background
                @size-change="changeCourseSize"
                @current-change="changeCoursePage"
                :current-page="pages.current"
                :page-sizes="[12, 18, 24]"
                :page-size="pages.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pages.total">
            </el-pagination>
            </div>
            <publish-course ref="publish" @publish_success="queryCourse"></publish-course>
            <el-dialog
            title="课程发布记录"
            :visible.sync="dialogVisible"
            width="95rem">
            <Table
                    :totalSize="recordPages.total"
                    :pagination="true"
                    :operationWidth="350"
                    :currentPage="recordPages.current"
                    @changeCurrentPage="changeCurrentPage"
                    @changePageSize="changePageSize"
                    :pageSize="recordPages.size"
                    navHeight=40
                    ref="table"
                    :tableData="recordData"
                    :tableKey="tableKey"
                >
                <template slot="scope" slot-scope="data">
                    <p>{{ data.data.row.scope=='0'?'本校平台':'全平台' }}</p>
                </template>
            </Table>
            </el-dialog>
        </div>
        <filter-assembly ref="filter_assembly" @change_type="changeType" :filterOpt="{ssfl:classifyCode}">
            <template>
                <div class="filter-item">
                    <p>公开类型：</p>
                    <el-radio-group v-model="scope" @input="search">
                        <el-radio v-for="(item,index) in scopeOptions" :key="index" :label="item.value">{{ item.label }}</el-radio>
                    </el-radio-group>
                </div>
            </template>
        </filter-assembly>
        </div>
    </div>
</template>

<script>
import CourseCard from './common/CourseCard.vue';
import Utils from '@/assets/js/Utils';
import { PageList,DeleteCourse,PageQueryMyCourseAudit,CancelReleaseCourse,EndCourse } from '@/api/course';
import CreateCourse from '../course/CreateCourse.vue';
import PublishCourse from './common/PublishCourse.vue';
import FilterAssembly from '../backendSys/FilterAssembly.vue';
import CourseStatistics from './myselfCourse/CourseStatistics.vue';
import MyCourseDetail from './myselfCourse/MyCourseDetail.vue';
    export default {
        components:{ CourseCard, PublishCourse,CreateCourse, FilterAssembly, CourseStatistics, MyCourseDetail },
        data(){
            return {
                /**所属分类 */
                classifyCode:'',
                /**搜索关键字 */
                keywords:'',
                /**当前点击课程 */
                currentItem:{},
                /**列表数据 */
                tableData:[],
                /**是否禁用课程编辑的输入框 */
                isDisabled:false,
                /**公开类型 */
                scope:'',
                /**公开可选项 */
                scopeOptions:[
                    {
                        label:'全部',
                        value:''
                    },
                    {
                        label:'本校平台公开',
                        value:0
                    },
                    {
                        label:'全平台公开',
                        value:1
                    },
                ],
                /**发布记录弹窗 */
                dialogVisible:false,
                btn_group:[
                    {
                        method:'edit',
                        label:'编辑'
                    },
                    {
                        method:'del',
                        label:'删除'
                    },
                    {
                        method:'queryRecord',
                        label:'发布记录'
                    },
                ],
                /**是否可以发布 */
                isPublish:false,
                pages:{
                    current:1,
                    size:12,
                    total:0,
                    totalPages:0,
                },
                /**发布记录列表 */
                recordData:[],
                tableKey:[
                {name: '发布时间', value: 'createTime'},
                {name: '所属课程', value: 'courseName'},
                {name: '开始时间', value: 'startTime'},
                {name: '结束时间', value: 'endTime'},
                {name: '审核状态', value: 'status'},
                {name: '备注', value: 'auditRemark'},
                {name: '发布范围', value: 'scope',slot:'scope'},
                ],
                /**发布记录分页 */
                recordPages:{
                    current:1,
                    size:10,
                    total:0,
                }
            }
        },
        computed:{
            opt(){
                return this.$store.state.course.operation;
            }
        },
        methods:{
            /**过滤列表 */
            search(){
                this.pages.current=1;
                this.queryCourse();
            },
            openRecord(item){
                this.currentItem=item;
                this.queryRecord();
            },
            changeType(e){
                if(e.ssfl!==undefined){
                    this.classifyCode=e.ssfl;
                }
                this.search();
            },
            /**结束课程 */
            endCourse(item){
                this.$confirm('是否确认提前结束课程?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                EndCourse({id:item.openCourseId}).then(res=>{
                    if(res.code==200){
                        this.queryCourse();
                    }
                })
              })
            },
            /**获取课程数据 */
            courseInfo(item){
                this.$store.commit('course/changeOperation','courseStatstics');
                this.$store.commit('backend/changeOptlabel',item.courseName);
                this.currentItem=item;
            },
            /**打开过滤弹窗 */
            openFilter(){
                var dialog=this.$refs.filter_assembly;
                if(dialog){
                    dialog.show=!dialog.show;
                }
            },
            /**过滤按钮 */
            filterBtn(status){
                var arr=JSON.parse(JSON.stringify(this.btn_group));
                if(!['未发布','已结束','审核不通过','审核中'].includes(status)){
                    arr=[
                    {
                        method:'edit',
                        label:'编辑'
                    },
                    {
                        method:'queryRecord',
                        label:'发布记录'
                    },
                    ]
                    if(status!=='未开始'){
                        arr.push({
                        method:'endCourse',
                        label:'结束课程'
                    },)
                    }
                }
                return arr;
            },
            /**是否可以发布 */
            publishStatus(status){
                if(['未发布','已结束','审核不通过'].includes(status)){
                    return 'publish';
                }else if(status=='审核中'){
                    return 'cancel';
                }else{
                    return '';
                };
            },
            /**取消发布 */
            noPublish(item){
                this.$confirm('是否确认取消发布课程?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                CancelReleaseCourse({id:item.id}).then(res=>{
                    if(res.code==200){
                        this.$msg({
                            showClose: true,
                            message: "取消发布成功",
                            type: "success",
                        });
                        this.queryCourse();
                    }
                })
              })
            },
            /**获取我创建的课程 */
            queryCourse(){
                let params={
                    courseName:this.keywords,
                    classifyCode:this.classifyCode,
                    queryType:0,
                    scope:this.scope,
                    current:this.pages.current,
                    size:this.pages.size
                }
                PageList(params).then(res=>{
                    if(res.code==200){
                        this.tableData=res.data.records;
                        this.pages.total=res.data.total;
                    }
                })
            },
            /**切换课程分页 */
            changeCoursePage(e){
                this.pages.current=e;
                this.queryCourse();
            },
            /**切换课程size */
            changeCourseSize(e){
                this.pages.size=e;
                this.pages.current=1;
                this.queryCourse();
            },
            /**切换 */
            changeCurrentPage(e){
                this.recordPages.current=e;
                this.queryRecord();
            },
            changePageSize(e){
                this.recordPages.size=e;
                this.recordPages.current=1;
                this.queryRecord();
            },
            /**创建课程 */
            createCourse(){
                this.$store.commit('course/changeOperation','add');
                this.$store.commit('course/changeId','');
                this.$store.commit('backend/changeOptlabel','创建课程');
                this.isDisabled=false;
            },
            /**编辑课程 */
            editCourse(item){
                this.$store.commit('course/changeId',item.id);
                this.$store.commit('course/changeOperation','edit');
                this.$store.commit('backend/changeOptlabel','编辑课程');
                if(item.courseStatus&&!['未发布','已结束','审核不通过'].includes(item.courseStatus)){
                    this.isDisabled=true;
                }else{
                    this.isDisabled=false;
                }
            },
            /**删除课程 */
            deleteCourse(item){
                this.$confirm('是否确认删除课程?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                DeleteCourse({ids:[item.id]}).then(res=>{
                    if(res.code==200){
                        this.$msg({
                            showClose: true,
                            message: "删除成功",
                            type: "success",
                        });
                        if(this.tableData.length==1&&this.pages.current>1){
                            this.pages.current--;
                        }
                        this.queryCourse();
                    }
                })
              })
            },
            /**获取发布记录 */
            queryRecord(){
                this.dialogVisible=true;
                var params={
                "classifyCode": "",
                "courseCode": "",
                "courseName": "",
                "courseId":this.currentItem.id,
                "current": this.recordPages.current,
                "size": this.recordPages.size,
                }
                PageQueryMyCourseAudit(params).then(res=>{
                    if(res.code==200){
                        this.recordData=res.data.records;
                        this.recordPages.total=res.data.total;
                    }
                })
            },
            /**发布课程 */
            publish(item){
                var dialog=this.$refs.publish;
                if(dialog){
                    dialog.dialogVisible=true;
                    dialog.id=item.id;
                    dialog.periods=item.periods;
                }
            },
            /**详情 */
            detail(item){
                // this.$store.commit('course/changeId',item.id);
                // this.$store.commit('backend/changePath',this.$route.path);
                // this.$router.push({
                //     path:'/course/courseDetail',
                //     query:{
                //         id:item.id,
                //     }
                // });
                this.currentItem=item;
                this.$store.commit('course/changeOperation','courseDetail');
                this.$store.commit('backend/changeOptlabel','课程详情');
                this.$nextTick(()=>{
                    let dialog=this.$refs.my_course_detail;
                    if(dialog){
                        dialog.getInit();
                    }
                })
            },
            /**切换推荐课程 */
            changeRecommend(data){
                this.currentItem = data;
            }
        },
        mounted(){
            this.queryCourse();
            Utils.$on('refresh_list',this.queryCourse);
            Utils.$on('change_course_item',this.changeRecommend);
        },
        destroyed(){
            this.$store.commit('course/changeOperation','');
            this.$store.commit('backend/changeOptlabel','');
            Utils.$off('refresh_list',this.queryCourse);
            Utils.$off('change_course_item',this.changeRecommend);
        }
    }
</script>

<style lang="less" scoped>
.course-box{
    height: 100%;
    .create-course-box{
        height: 100%;
    }
}
.create-box{
    height: 100%;
}
.top-box{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.btn-box{
    width: 14rem;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e8ecef;
    border-radius: 10px;
    color: #ffffff;
    transition: all 0.3s;
    cursor: pointer;
    background-color: var(--blue);
    i{
        margin-right: 3px;
        font-size: 2rem;
    }
}
.input-box{
    display: flex;
    align-items: center;
    color: #334681;
    &> :nth-child(1){
        margin-right: 1.3rem;
        cursor: pointer;
        color: #8590B3;
    }
}
.card-content{
    padding-top: 2rem;
    height: calc(100% - 9rem);
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 2rem;
    .card-item{
        width: calc((100% - 10rem)/6) !important;
    }
    // &> :nth-child(n+7){
    //     margin-top: 2rem;
    // }
    // &> :nth-child(n){
    //     margin-left: 2rem;
    // }
    // &> :nth-child(6n+1){
    //     margin-left: 0;
    // }
}
/deep/.el-dialog__title{
    font-weight: 700;
}
/deep/.top-box-1{
    padding:3rem;
    border: 1px solid #e0e8f2;
    border-radius: 10px;
    height: 100%;
    overflow: auto;
}
/deep/.route-title{
    display: none;
}
/deep/.content-box{
    margin-top: 0;
}
.filter-item{
            color: #8590B3;
            font-size: 12px;
            display: flex;
            align-items: center;
            &> :nth-child(1){
                margin-right: 1rem;
            }
        }
.category-box{
    display: flex;
    &> :nth-child(n){
        margin-left: 3.5rem;
    }
    &> :nth-child(1){
        margin-left: 0;
    }
    .category-item{
        padding: 0.2rem 1rem;
        border-radius: 1rem;
        color: #334681;
        background-color: transparent;
        cursor: pointer;
    }
}
.active{
    color: #ffffff !important;
    background-color: var(--blue) !important;
}
.input-box{
/deep/.el-input__inner{
    height: 4rem;
    border-radius: 1rem;
    padding-left: 3.5rem;
}
.search-ipt-box{
    display: flex;
    align-items: center;
    width: 3.5rem;
    justify-content: center;
    height: 100%;
}
}
/deep/.el-dialog{
    border-radius: 1rem;
}
/deep/.el-radio__label{
    font-size: 12px;
}
</style>